import React from "react";
import { useNavigate } from "react-router-dom";
import { BackArrowButton } from "../backArrowButton/BackArrowButton";

export const GoHomeButton = (props) => {
  const navigate = useNavigate();
  return (
    <BackArrowButton
      messageId="back_to_dashboard"
      {...props}
      onClick={() => navigate("/home")}
    />
  );
};
